import React from 'react';
import {
  DocumentTextIcon,
  DocumentIcon,
  TableCellsIcon,
  PresentationChartBarIcon,
  MusicalNoteIcon,
  VideoCameraIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';
import { ResourceLinkKind } from '../../types';
import { t } from '../../utils/translations';

interface ResourceKindIconProps {
  kind: ResourceLinkKind;
  className?: string;
}

const ResourceKindIcon: React.FC<ResourceKindIconProps> = ({
  kind,
  className = 'h-4 w-4 shrink-0',
}) => {
  if (kind === 'sheet') {
    return <TableCellsIcon className={`${className} text-emerald-600`} aria-hidden />;
  }
  if (kind === 'doc') {
    return <DocumentTextIcon className={`${className} text-blue-600`} aria-hidden />;
  }
  if (kind === 'powerpoint') {
    return <PresentationChartBarIcon className={`${className} text-orange-600`} aria-hidden />;
  }
  if (kind === 'pdf') {
    return <DocumentIcon className={`${className} text-red-600`} aria-hidden />;
  }
  if (kind === 'audio') {
    return <MusicalNoteIcon className={`${className} text-violet-600`} aria-hidden />;
  }
  if (kind === 'video') {
    return <VideoCameraIcon className={`${className} text-rose-600`} aria-hidden />;
  }
  return <LinkIcon className={`${className} text-slate-500`} aria-hidden />;
};

export function resourceKindShortLabel(kind: ResourceLinkKind): string {
  return t.resources.kindShort[kind];
}

export default ResourceKindIcon;
